'use client';

import { HeadingProps as CKHeadingProps, chakra } from '@chakra-ui/react';

type HeadingKind = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';

export type HeadingStyles = '2xl' | 'xl' | 'l' | 'm' | 's' | 'xs' | '2xs' | 'allCapL' | 'allCapM' | 'allCapS';

export interface HeadingProps extends Omit<CKHeadingProps, 'as'> {
  /**
   * The heading tag that should be used
   */
  as: HeadingKind;

  /**
   * The style that the heading should used
   */
  styleType: HeadingStyles;
}

const Heading = ({
  as = 'h1',
  children,
  color = 'text/heading',
  styleType,
  textAlign = 'left',
  ...rest
}: HeadingProps) => {
  return (
    <chakra.h1 as={as} color={color} textAlign={textAlign} textStyle={`heading.${styleType}`} {...rest}>
      {children}
    </chakra.h1>
  );
};

export default Heading;
